import { StatusBar } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { ErrorBoundary } from '~/components/ErrorBoundary';
import { AuthGate } from '~/gate/AuthGate';
import { AuthProvider } from '~/hooks/useAuth';
import { ThemeProvider } from '~/theme/ThemeProvider';

/**
 * App providers tree: SafeArea → Theme → Auth → AuthGate(screens).
 *
 * Theme sits above Auth because the login screen and the shell both read the
 * palette, and outside the provider useTheme silently falls back to dark.
 *
 * TWO error boundaries, at different depths, because they recover different amounts.
 * The inner one wraps only the screens, so a render throw inside a screen leaves the
 * providers mounted and the operator STILL SIGNED IN — retry costs a re-render, not a
 * re-login. The outer one is the backstop for a provider or SafeArea failure, which the
 * inner one sits below and cannot see. Without the outer one those crashes would still
 * take the process down silently, which is the whole failure mode being closed here.
 */
export function App() {
  return (
    <ErrorBoundary>
      <SafeAreaProvider>
        {/*
          Dark glyphs, because Phase 17 put the app on one LIGHT theme. This said
          light-content, which was correct for the old dark palette and paints white
          icons on a white status bar. The three camera screens set it back to
          light-content themselves while they are mounted.
        */}
        <StatusBar barStyle="dark-content" />
        <ThemeProvider>
          <AuthProvider>
            <ErrorBoundary label="glass classify">
              <AuthGate />
            </ErrorBoundary>
          </AuthProvider>
        </ThemeProvider>
      </SafeAreaProvider>
    </ErrorBoundary>
  );
}
